import { Navigate, Routes, Route } from 'react-router-dom'
import React, { lazy, useEffect } from 'react'
import { useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { RightsAdministrationPage } from 'src/Libs/installation-rights-management'
import { DashboardGuidedTour, useDashboardTourAvailability, useDashboardTour } from 'src/Libs/dashboard/guided-tour'
import RequireStorageId from 'src/Elements/RequireStorageId/RequireStorageId'
import InstallationRouteGuard from 'src/Libs/navigation/components/InstallationRouteGuard'
import { SYSTEM_STATUS_TAB_PATHS } from 'src/Libs/system-status'

const InstallationDocuments = lazy(() => import('./User/Documents'))
const SystemStatus = lazy(() => import('./system-status/SystemStatusPage'))
const Dashboard = lazy(() => import('./User/Dashboard'))

const DashboardRoute: React.FC = () => {
  const { setActiveTab } = useHeaderTabs()

  const isDashboardTourAvailable = useDashboardTourAvailability()
  const { tour, setTourRunning } = useDashboardTour()
  useEffect(() => {
    setTourRunning(isDashboardTourAvailable)
    return () => {
      setActiveTab(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDashboardTourAvailable, setTourRunning])

  return (
    <React.Fragment key={String(tour.isRunning)}>
      <DashboardGuidedTour />
      <Routes>
        <Route
          path={`/overview/:installationId/:storageId?`}
          element={
            <InstallationRouteGuard>
              <RequireStorageId allowAccessWithoutStorageId>
                <Dashboard />
              </RequireStorageId>
            </InstallationRouteGuard>
          }
        />
        {/* Tab urls without a storage id: matched explicitly, otherwise the tab segment would be taken for the storage id below */}
        {SYSTEM_STATUS_TAB_PATHS.map(tabPath => (
          <Route
            key={tabPath}
            path={`/system-status/:installationId/${tabPath}`}
            element={
              <InstallationRouteGuard>
                <RequireStorageId>
                  <></>
                </RequireStorageId>
              </InstallationRouteGuard>
            }
          />
        ))}
        <Route
          path={`/system-status/:installationId/:storageId?/*`}
          element={
            <InstallationRouteGuard>
              <RequireStorageId>
                <SystemStatus />
              </RequireStorageId>
            </InstallationRouteGuard>
          }
        />
        <Route
          path={`/documents/:installationId/:storageId?`}
          element={
            <InstallationRouteGuard>
              <RequireStorageId>
                <InstallationDocuments />
              </RequireStorageId>
            </InstallationRouteGuard>
          }
        />
        <Route
          path={`/rights-administration/:installationId/:storageId?`}
          element={
            <InstallationRouteGuard>
              <RequireStorageId allowAccessWithoutStorageId>
                <RightsAdministrationPage />
              </RequireStorageId>
            </InstallationRouteGuard>
          }
        />
        <Route path={'*'} element={<Navigate to="/" />} />
      </Routes>
    </React.Fragment>
  )
}

export default DashboardRoute
